import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { MOOD_PROFILES } from '@/lib/scoring'

interface MoodSelectorProps {
  currentMood: string
  onMoodChange: (mood: string) => void
}

// Mood icons mapping
const MOOD_ICONS = {
  productive: '🎯',
  creative: '🎨', 
  balanced: '⚖️',
  quickWins: '⚡'
}

export default function MoodSelector({ currentMood, onMoodChange }: MoodSelectorProps) {
  const currentMoodProfile = MOOD_PROFILES[currentMood]
  const currentIcon = MOOD_ICONS[currentMood as keyof typeof MOOD_ICONS]

  return (
    <Menu as="div" className="relative inline-block">
      <MenuButton className="inline-flex w-full justify-center gap-x-2 rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-white dark:ring-gray-600 dark:hover:bg-gray-700">
        <span className="text-lg">{currentIcon}</span>
        {currentMoodProfile?.label || 'Select Mood'}
        <ChevronDownIcon aria-hidden="true" className="-mr-1 h-5 w-5 text-gray-400" />
      </MenuButton>

      <MenuItems className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none dark:bg-gray-800 dark:ring-gray-600">
        <div className="py-1">
          {Object.entries(MOOD_PROFILES).map(([key, mood]) => (
            <MenuItem key={key}>
              {({ active }) => (
                <button
                  onClick={() => onMoodChange(key)}
                  className={`${
                    active ? 'bg-gray-100 dark:bg-gray-700' : ''
                  } ${
                    currentMood === key ? 'bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-300' : 'text-gray-700 dark:text-gray-200'
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  <span className="mr-3 text-lg">
                    {MOOD_ICONS[key as keyof typeof MOOD_ICONS]}
                  </span>
                  <div className="flex flex-col items-start">
                    <span className="font-medium">{mood.label}</span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">
                      Focus: {Math.round(mood.importanceWeight * 100)}% Important, {Math.round(mood.urgencyWeight * 100)}% Urgent, {Math.round(mood.enjoymentWeight * 100)}% Enjoyable
                    </span>
                  </div>
                </button>
              )}
            </MenuItem>
          ))}
        </div>
      </MenuItems>
    </Menu>
  )
}